import { createSelector } from 'reselect';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [taxDetailsAllIds, taxDetailsById, allTaxDetailsSelector] =
  resourceSelectors('taxDetails');
